import { css } from '@compiled/react';
import { LoggedInUser, SharedFooter } from '@atlassian/learning-components';
import { MOBILE, TABLET } from '../../utils/constants';

interface Props {
  isLoggedIn: boolean;
  loggedInUser: LoggedInUser;
}

export const Footer = ({ isLoggedIn, loggedInUser }: Props) => (
  <>
    <div css={footerSpacerStyles} />
    <SharedFooter isLoggedIn={isLoggedIn} email={loggedInUser.email} />
  </>
);

const footerSpacerStyles = css({
  height: '112px',
  [TABLET.MEDIA_QUERY]: {
    height: '72px',
  },
  [MOBILE.MEDIA_QUERY]: {
    height: '64px',
  },
});
